import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M0 0v18h18V0H0zm16.8 16.8H1.2V1.2h15.6v15.6zM5.819 14.47l.424.425L11.2 9.938l2.699 2.7V3.996l-8.639.001 2.727 2.727-2.168 2.167a3.95 3.95 0 0 0 0 5.579zm.849-4.732l3.016-3.015-1.528-1.527 4.544-.001v4.544L11.201 8.24 6.29 13.151a2.725 2.725 0 0 1-.426-1.472c0-.732.285-1.421.804-1.941z" />
  </svg>
);

export default SvgComponent;
